<template>
  <Toast/>
  <div class="row">
    <div class="col">

      <div class="row">
        <div class="col">
          <div class="page-header centrer">
            <div class="row">
              <div class="col-1"/>
              <div class="col-10">
                <h1>Audits des changements - Suivis</h1>
              </div>
              <div class="col-1 text-right no-print">
                <Button class="no-print" label="Fermer" v-on:click="fermer"/>
              </div>
            </div>
            <h3 class="confidentiel">Confidentiel</h3>
            <h3 v-if="isDataLoaded">
              Enregistrement créé le : {{ this.$commun.formatDateHeure(suivi.creerLe) }} <br />
              Par : {{suivi.creerParDescription}} <br />
            </h3>
            <div v-else>
              <Skeleton />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
            <div class="col">
              <table class="centrer">
                <thead>
                  <tr>
                    <td>
                      <!--place holder for the fixed-position header-->
                      <div class="page-header-space"></div>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <!--*** CONTENT GOES HERE ***-->
                      <div>
                        <TableModificationsSuivi @backendError="showError" @isDataLoaded="getIsDataLoaded"/>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td>
                      <!--place holder for the fixed-position footer-->
                      <div class="page-footer-space"></div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="page-footer centrer">
            <p>Produit le {{ getCurrentDateTime() }} par {{ currentUser }}</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import TableModificationsSuivi from "../../../components/dossier/AuditModifications/TableModificationsSuivi.vue";
import axios from 'axios';
import { mapGetters } from "vuex";

export default {
  name: "AuditModificationsSuivi",
  components: {TableModificationsSuivi},
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$store.dispatch("suivi/obtenirProfilSuiviAction")
    .then((res) => {
      this.assignerInformationUtilisateur(res);
    });
    this.$root.$refs.breadcrumbComp.ajout("Audits des Suivis");
  },
  data() {
    return {
      currentUser: "",
      isDataLoaded: false,
    };
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
      suivi: "suivi/suivi",
    }),
  },
  methods: {
    assignerInformationUtilisateur(res) {
      this.currentUser = res.data.codeProfilUtilisateur;
    },
    fermer() {
        this.$router.push({
            name:'consulterSuivi', 
            params:{cle:this.$route.params.cle, site:this.$route.params.site}
        });
    },
    getCurrentDateTime() {
      return this.$commun.formatDateHeure(new Date());
    },
    getIsDataLoaded(value) {
      this.isDataLoaded = value;
    },
    showError(error) {
      this.$toast.add({
        severity: 'error',
        summary: 'Audits',
        detail: 'Erreur lors de la récupération des audits du suivi: ' + error,
        life: 5000
      })
    },
  },
};
</script>
